import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainFolderModuleRoutingModule } from './main-folder-routing.module';
import { MainFolderModuleComponent } from './main-folder.component';

// OTHER MODULE IMPORTS

import { SharedModule } from '../../shared.module';
import { MaterialsModule } from '../../materials.module';


// IMPORT FOLDER MODULE COMPONENTS
import { FolderComponent } from '../folder.component';
import { CreateFolderModalComponent } from '../create-folder-modal/create-folder-modal.component';
import { SingleFolderComponent } from '../single-folder/single-folder.component';
import { ShareFileModalComponent } from '../share-file-modal/share-file-modal.component';

@NgModule({
  declarations: [
    MainFolderModuleComponent,
    SingleFolderComponent,
    FolderComponent,
    CreateFolderModalComponent,
    ShareFileModalComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialsModule,
    MainFolderModuleRoutingModule
  ],
  entryComponents: [
    CreateFolderModalComponent,
    ShareFileModalComponent,
  ],
  exports: [
    SingleFolderComponent,
    FolderComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

})
export class MainFolderModuleModule { }
